import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import {
  Form,
  SidebarFormHeader,
  TextfieldElement,
  SelectElement,
  SidebarFormFooter,
  AutocompleteTextfieldApiElement,
  withAuthentication,
  withCourseGroupsApi,
  DateISO8601Element,
  withProvidersApi,
  Role,
} from "cw-styleguide-react";
import withAssets from "../../../components/hoc/withAssets";
import i18n from "../../../i18n";
import { ROLE_STAFF } from "../../../constants";

class CoursesManageFilterForm extends Component {
  render() {
    return (
      <Form theme={["sidebar"]} classes={["sidebar--can-collapse"]}>
        <SidebarFormHeader
          heading={this.props.t("styleguide:forms.filterBy")}
          searchButtonText={this.props.t("styleguide:forms.applyFilters")}
          handleSubmit={this.props.handleSubmit}
          handleReset={this.props.handleReset}
        />
        <div className="form__body">
          <TextfieldElement
            id={"courseId"}
            name={"courseId"}
            label={this.props.t("view.courses.manage.field.courseId.label")}
            value={this.props.values.courseId}
            onChange={this.props.handleChange}
          />
          <TextfieldElement
            id={"courseTitle"}
            name={"courseTitle"}
            label={this.props.t("view.courses.manage.field.courseTitle.label")}
            value={this.props.values.courseTitle}
            onChange={this.props.handleChange}
          />
          <SelectElement
            id={"courseStatus"}
            name={"courseStatus"}
            label={this.props.t("view.courses.manage.field.courseStatus.label")}
            value={this.props.values.courseStatus}
            onChange={this.props.handleChange}
            options={[
              {
                value: "",
                label: this.props.t("styleguide:forms.all"),
              },
            ].concat(this.props.courses.assets.courses.statuses[i18n.language])}
          />
          <SelectElement
            id={"courseGroupType"}
            name={"courseGroupType"}
            label={this.props.t(
              "view.courses.manage.field.courseGroupType.label"
            )}
            value={this.props.values.courseGroupType}
            onChange={this.props.handleChange}
            options={[
              {
                value: "",
                label: this.props.t("styleguide:forms.all"),
              },
            ].concat(this.props.courses.assets.courseGroups.courseGroupType)}
          />
          {/* Main Provider */}
          <Role roles={[ROLE_STAFF]}>
            <AutocompleteTextfieldApiElement
                api={this.props.providersApiGetEndpoint("providers_api_provider")}
                authorize={true}
                size={"large"}
                name={"mainProvider"}
                label={this.props.t(
                    "local:view.courses.manage.field.mainProvider.label"
                )}
                queryParameter={"name"}
                acceptLanguage={i18n.language}
                keyField={"atlasAccountId"}
                valueField={"providerName"}
                placeholder={this.props.t(
                    "local:view.courses.manage.field.mainProvider.placeholder"
                )}
                value={this.props.values.mainProviderId}
                keyword={this.props.values.mainProviderLabel}
                onChange={this.props.handleChange}
            />
          </Role>

          <AutocompleteTextfieldApiElement
            size={"medium"}
            name={"courseGroup"}
            label={this.props.t(
              "local:view.courses.manage.field.courseGroupName.label"
            )}
            placeholder={this.props.t(
              "local:view.courses.manage.field.courseGroupName.placeholder"
            )}
            api={this.props.courseGroupsApiGetEndpoint(
              "course_groups_api_course_groups_mq"
            )}
            authorize={true}
            queryParameter={"search"}
            keyField={"courseGroupId"}
            valueField={"courseGroupName"}
            additionalParameters={{
              atlasAccountId: this.props.authentication.hasRole(
                "Courses_Provider"
              )
                ? this.props.authentication.getClaim("atlasAccountId")
                : this.props.values.mainProviderId,
            }}
            keyword={this.props.values.courseGroupLabel}
            acceptLanguage={i18n.language}
            value={this.props.values.courseGroupId}
            onChange={this.props.handleChange}
          />



          <DateISO8601Element
            id={"courseReviewDate"}
            name={"courseReviewDate"}
            label={this.props.t(
              "local:view.courses.manage.field.courseReviewDate.label"
            )}
            value={this.props.values.courseReviewDate}
            onChange={this.props.handleChange}
          />
          <SidebarFormFooter
            handleSubmit={this.props.handleSubmit}
            handleReset={this.props.handleReset}
            searchButtonText={this.props.t("styleguide:forms.applyFilters")}
          />
        </div>
      </Form>
    );
  }
}

export default withProvidersApi(process.env)(
  withCourseGroupsApi(process.env)(
    withAuthentication(
      withAssets(withTranslation("local")(CoursesManageFilterForm))
    )
  )
);
